import { render, staticRenderFns } from "./Form158.vue?vue&type=template&id=0bd824c0&scoped=true&"
import script from "./Form158.vue?vue&type=script&lang=js&"
export * from "./Form158.vue?vue&type=script&lang=js&"
import style0 from "./Form158.vue?vue&type=style&index=0&id=0bd824c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd824c0",
  null
  
)

export default component.exports